







































































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import ListUtils from '@/lib/listUtils';
import Amount from '@/models/Shared/Amount';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import FeeDefinition from '@/models/Products/ProductFees/FeeDefinition';
import {v4 as uuidv4} from 'uuid';
import FeeDefintionType from '@/models/Products/ProductFees/FeeDefinitionType';

@Component({ name: 'LendingFeeDefinitionCreate' })
export default class extends SaascadaVueDialog {

    feeDefinitionType = FeeDefintionType;
    entity: FeeDefinition = new FeeDefinition();
    amountAsNumber: number = 0;

    @Prop({required: true})
    currency: string;

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.entity = new FeeDefinition();
        }
    }

    get feeDefinitionTypes() {
        return ListUtils.feeDefinitionTypeOptions();
    }

    async save() {
        // if (!(this.$refs.form as any).validate()) {
        //   return;
        // }

        this.dialog = false;

        this.entity.id = uuidv4();
        this.entity.amount = new Amount();
        this.entity.amount.amount = this.amountAsNumber.toString();
        this.entity.amount.currency = this.currency;

        await ProductWizardModule.createFeeDefinition(this.entity);
    }

}
